// Framework
import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { FileNotFoundComponent } from './404.component'

const routes: Routes = [
  {
    path: '',
    component: FileNotFoundComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FileNotFoundRoutingModule {}
